import { Link } from 'react-router-dom';
import { articles, Article } from '@/mocks/articles';

const featuredArticles = articles.slice(0, 3);

export default function FeaturedWorks() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-600 max-w-lg mx-auto">
          编辑团队精心挑选的优质纲手本子作品，每一件都值得细细品味
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {featuredArticles.map((article: Article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full h-48 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs rounded-full font-medium">
                {article.category}
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>{article.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>{(article.views / 1000).toFixed(1)}k
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 border border-background-300/60 rounded-full text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          查看全部作品 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}